import { FormlyFieldConfig } from "@ngx-formly/core";
import { AllegatiPassoCarraioStep } from "./steps/allegati-passocarraio.step";
import { OccupazionePassoCarraioStep } from "./steps/occupazione-passocarraio";
import { RichiestaPassoCarraioStep } from "./steps/richiesta-passocarraio.step";
import { GiuridicaStep } from "app/forms/shared/giuridica.step";
import { IntestatarioStep } from "app/forms/shared/intestatario.step";
import { PrivacyDelegaStep } from "app/forms/shared/privacy-delega.step";
import { UbicazioneStep } from "../shared/ubicazione.step";
import { IntestatarioTipo } from "app/forms/shared/intestatario.tipo";

export const PassoCarraio: FormlyFieldConfig[] = [
        {
            props: {
                slabel: "PRIVACY",
                label: "INFORMATIVA SULLA PRIVACY"
            },
            wrappers: ['panel-step'],
            fieldGroup: PrivacyDelegaStep
        },
        {
            props: {
                slabel: "INTESTATARIO",
                label: "DATI ANAGRAFICI INTESTATARIO"
            },
            wrappers: ['panel-step'],
            fieldGroup: [...IntestatarioTipo, ...IntestatarioStep, ...GiuridicaStep]
        },
      {
        props: {
          slabel: "UBICAZIONE",
          label: "UBICAZIONE DEL DEHOR IN MAPPA",
        },
        wrappers: ['panel-step'],
        fieldGroup: UbicazioneStep
      },
      {
        props: {
          slabel: 'RICHIESTA',
          label: 'DATI DELLA RICHIESTA'
        },
        wrappers: ['panel-step'],
        fieldGroup: RichiestaPassoCarraioStep
      },
      {
        props: {
          slabel: 'OCCUPAZIONE',
          label: 'ELEMENTI DI OCCUPAZIONE SUOLO PER PASSO CARRAIO'
        },
        wrappers: ['panel-step'],
        fieldGroup: OccupazionePassoCarraioStep
      },
       {
        props: {
          slabel: 'ALLEGATI',
          label: 'DOCUMENTAZIONE ALLEGATA'
        },
         wrappers: ['panel-step'],
         fieldGroup: AllegatiPassoCarraioStep
       },
    ]

